import Button from 'components/Button/index'
import { TopHeader } from 'modules/Roles/ViewRole/Style/style'
import React, { useState } from 'react'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'
import {
  CardSectionFlex,
  CardText,
  CardsFlex,
  CardsRowFlex,
  CardsValue,
} from '../../Style/style'
import QuestionnaireExport from './QuestionnaireExport'

const Metrics = ({
  setSelectedRound,
  selectedRound,
  rolesMetrics,
  setCurrentPage,
  setCandidateStatus,
  candidateStatus,
  setSelectedRowKeys,
  setPageNum,
  questionaireDBList,
  singleRoleData,
  setCollege,
  setCandidateFilterData,
  setSearchValue,
}) => {
  const [exportCard, setExportCard] = useState([])
  const [selectedFileType, setSelectedFileType] = useState('xlsx')
  const [exportVisible, setExportVisible] = useState(false)

  const onHanldleModal = key => {
    setExportVisible(true)
  }

  const onHanldleCloseModal = key => {
    setExportVisible(false)
    setExportCard([])
    setSelectedFileType('xlsx')
  }

  const onClickRound = value => {
    setCurrentPage(0)
    setPageNum(0)
    setCandidateStatus(
      value === 'Shortlisted Candidates'
        ? 1
        : value === 'Rejected Candidates'
        ? -1
        : ''
    )
    setSelectedRound(value)
    setSelectedRowKeys([])
    setCollege('')
    setCandidateFilterData({
      rating: '',
      yearOfEx: '',
      degreeDepartment: '',
      instituteCampusIds: '',
      degreekeys: '',
      location: '',
      latestCompany: '',
      latestRole: '',
    })
    setSearchValue('')
  }

  return (
    <TopHeader row spaceBetween alignCenter>
      <CardsRowFlex row wrap>
        {rolesMetrics?.map((role, index) => (
          <CardSectionFlex key={index + 'roleMetrics'} centerVertically>
            <CardsFlex
              column
              onClick={() =>
                questionaireDBList?.totalCount != 0 && onClickRound(role?.name)
              }
              isSelected={selectedRound === role?.name}
              roundName={selectedRound}
              style={{
                pointerEvents: selectedRound === role?.name ? 'none' : 'auto',
                width: '100%',
              }}
            >
              <CardText
                isSelected={selectedRound == role?.name}
                roundName={selectedRound}
              >
                {role?.name}
              </CardText>
              <CardsValue
                isSelected={selectedRound == role?.name}
                roundName={selectedRound}
              >
                {getZeroBeforeInt(role?.count)}
              </CardsValue>
            </CardsFlex>
          </CardSectionFlex>
        ))}
      </CardsRowFlex>
      {questionaireDBList?.totalCount !== 0 &&
        ((selectedRound === 'Shortlisted Candidates' &&
          questionaireDBList?.shortListedCount !== 0) ||
          (selectedRound === 'Applied Candidates' &&
            questionaireDBList?.totalCount !== 0) ||
          (selectedRound === 'Rejected Candidates' &&
            questionaireDBList?.rejectedCount !== 0)) && (
          <Button.Secondary
            height={'38px'}
            text={'Export'}
            style={{
              borderColor: '#5db594',
              padding: '20px',
              color: '#5db594',
            }}
            onClick={onHanldleModal}
          />
        )}

      {exportVisible && (
        <QuestionnaireExport
          exportVisible={exportVisible}
          candidateStatus={candidateStatus}
          onHanldleCloseModal={onHanldleCloseModal}
          setExportCard={setExportCard}
          exportCard={exportCard}
          setSelectedFileType={setSelectedFileType}
          selectedFileType={selectedFileType}
          singleRoleData={singleRoleData}
        />
      )}
    </TopHeader>
  )
}

export default Metrics
